import i18n from '@/i18n';
import { dateSortFunction } from '@/tools/functions';
import { CellType, DataType, FilterType } from '@colven/common-domain-lib/lib';

export const NOTIFICATION_STATUS_HEADERS = [
    {
        text: i18n.t('notificationStatus.table.status'),
        align: 'center',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        cellType: CellType.textBackgroundColor,
        cellConfig: {
            color: 'color',
            outlined: false,
            round: false
        },
        value: 'statusQuantity',
        spinner: false,
        width: 100,
    },
    {
        text: i18n.t('notificationStatus.table.server'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'server',
        spinner: false,
        width: 100,
    },
    {
        text: i18n.t('notificationStatus.table.user'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'user',
        spinner: false,
        width: 150,
    },
    {
        text: i18n.t('notificationStatus.table.received_date'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        cellType: CellType.text,
        value: 'received_date',
        spinner: false,
        width: 180,
        sort: (a, b) => { return dateSortFunction(a, b, 'DD/MM/YYYY HH:mm:ss') }
    },
    {
        text: i18n.t('notificationStatus.table.notification'),
        align: 'left',
        filterType: FilterType.textField,
        selected: true,
        sortable: true,
        type: DataType.string,
        value: 'dataJson',
        spinner: false,
        width: 1000,
    },
]